export const HOST_LIST_PRODUCT = "HOST_LIST_PRODUCT";
export const HOST_LIST_PRODUCT_SUCCESSFUL = "HOST_LIST_PRODUCT_SUCCESSFUL";
export const HOST_LIST_PRODUCT_FAILED = "HOST_LIST_PRODUCT_FAIELD";

export const HOST_LIST_PRODUCT_SORT = "HOST_LIST_PRODUCT_SORT";
export const HOST_LIST_PRODUCT_SORT_SUCCESSFUL = "HOST_LIST_PRODUCT_SORT_SUCCESSFUL";
export const HOST_LIST_PRODUCT_SORT_FAILED = "HOST_LIST_PRODUCT_SORT_FAILED";

